//
import { createActionsCurried } from '../../utils/actions';
import { appName } from '../../constants/config';

const moduleName = 'user';
const prefix = `${appName}/${moduleName}`;
const buildActions = createActionsCurried(prefix);

export const [
  GET_USER_PROFILE_REQUEST,
  GET_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE_ERROR
] = buildActions('GET_USER_PROFILE');

export const GET_CURRENT_USER_MACHINE_GROUPS_REQUEST =
  'GET_CURRENT_USER_MACHINE_GROUPS_REQUEST';
export const GET_CURRENT_USER_MACHINE_GROUPS_SUCCESS =
  'GET_CURRENT_USER_MACHINE_GROUPS_SUCCESS';
export const GET_CURRENT_USER_MACHINE_GROUPS_ERROR =
  'GET_CURRENT_USER_MACHINE_GROUPS_ERROR';

export const SELECT_MACHINE_GROUPS = 'SELECT_MACHINE_GROUPS';
export const SELECT_MACHINE_GROUP_MACHINES = 'SELECT_MACHINE_GROUP_MACHINES';

export const GET_USER_PROFILE_DATA_REQUEST = 'GET_USER_PROFILE_DATA_REQUEST';
export const GET_USER_PROFILE_DATA_SUCCESS = 'GET_USER_PROFILE_DATA_SUCCESS';
export const GET_USER_PROFILE_DATA_ERROR = 'GET_USER_PROFILE_DATA_ERROR';

export const GET_USER_COMPANIES_REQUEST = 'GET_USER_COMPANIES_REQUEST';
export const GET_USER_COMPANIES_SUCCESS = 'GET_USER_COMPANIES_SUCCESS';
export const GET_USER_COMPANIES_ERROR = 'GET_USER_COMPANIES_ERROR';
